module.exports = __webpack_public_path__ + "img/2.70aabb60.jpg";